<ng-container *appHasPermission="{ resource: Resources.MerchantWallets, scope: Scopes.Read }">
  <app-form-container [heading]="'Wallet Check'">
    <form [formGroup]="walletCheckForm">
      <div class="form-group">
        <app-text-input
          label="Wallet address"
          type="text"
          placeholder="Enter wallet address"
          formControlName="walletAddress"
          [disable]="isLoading()"
          [isInvalid]="getFieldError('walletAddress', 'Wallet address') !== '' || errorMessage() !== ''"
          [errorMessage]="
            getFieldError('walletAddress', 'Wallet address') || errorMessage()
          "
          [showRestField]="true"
          (restField)="onReset()"
        ></app-text-input>
      </div>

      @if (hasResult()) {
        <div class="result" [ngClass]="{ success: isValidWallet(), failed: !isValidWallet() }">
          @if (isValidWallet()) {
            <mat-icon>check_circle</mat-icon>
          } @else {
            <mat-icon>error_outline</mat-icon>
          }
          <span> {{ getMessageResult() }}</span>
        </div>
      }
    </form>

    <div class="form-actions">
      <button
        type="submit"
        color="primary"
        class="btn-submit"
        [disabled]="!walletCheckForm.valid || isLoading()"
        (click)="onSubmit()"
      >
        @if (!isLoading()) {
          <span>Check</span>
        } @else {
          <app-loading-spinner size="small"></app-loading-spinner>
        }
      </button>
    </div>
  </app-form-container>
</ng-container>
